export default __webpack_public_path__ + "static/media/s3.998c4970.png";